class StoreProfile {
  constructor (
    id = undefined,
    firstName,
    lastName,
    email,
    identifier,
    phoneNumber,
    password,
    familyId,
    languageId,
    roleId,
    photoId,
    deviceIds,
    assignedUserIds,
    visibleFamilyIds,
    smsDangerMessages,
    smsNormalMessages,
    emailDangerMessages,
    emailNormalMessages,
    browserNotification,
    theme,
    hasPassword
  ) {
    this.id = id
    this.firstName = firstName
    this.lastName = lastName
    this.email = email
    this.identifier = identifier
    this.phoneNumber = phoneNumber
    this.password = password
    this.familyId = familyId
    this.family = null
    this.languageId = languageId
    this.language = null
    this.roleId = roleId
    this.role = null
    this.photoId = photoId
    this.photo = null
    this.deviceIds = deviceIds
    this.assignedUserIds = assignedUserIds
    this.visibleFamilyIds = visibleFamilyIds
    this.devices = []
    this.smsDangerMessages = smsDangerMessages
    this.smsNormalMessages = smsNormalMessages
    this.emailDangerMessages = emailDangerMessages
    this.emailNormalMessages = emailNormalMessages
    this.browserNotification = browserNotification
    this.theme = theme
    this.hasPassword = hasPassword
  }

  toNormalizedRESTModel () {
    const model = {
      // id is read-only
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      userName: this.identifier,
      mobilePhone: this.phoneNumber,
      // familyId is read-only
      languageId: this.languageId != null && this.languageId !== ''
        ? Number(this.languageId)
        : undefined,
      // roleId is read-only
      photoId: this.photoId,
      // deviceIds / assignedUserIds / visibleFamilyIds are read-only
      smsDangerMessages: this.smsDangerMessages,
      smsNormalMessages: this.smsNormalMessages,
      emailDangerMessages: this.emailDangerMessages,
      emailNormalMessages: this.emailNormalMessages
    }

    if (this.theme && String(this.theme).trim()) {
      model.theme = this.theme
    }

    return model
  }

  static FromNormalizedRESTModel ({
    id,
    firstName,
    lastName,
    email,
    userName,
    mobilePhone,
    familyId,
    languageId,
    roleId,
    photoId,
    deviceIds,
    assignedUserIds,
    visibleFamilyIds,
    smsDangerMessages,
    smsNormalMessages,
    emailDangerMessages,
    emailNormalMessages,
    browserNotification,
    theme,
    hasPassword
  }) {
    const resolvedHasPassword = typeof hasPassword === 'boolean' ? hasPassword : undefined

    return new StoreProfile(
      id,
      firstName,
      lastName,
      email,
      userName,
      mobilePhone,
      undefined,
      familyId,
      languageId,
      roleId,
      photoId,
      deviceIds,
      assignedUserIds,
      visibleFamilyIds,
      smsDangerMessages,
      smsNormalMessages,
      emailDangerMessages,
      emailNormalMessages,
      browserNotification,
      theme,
      resolvedHasPassword
    )
  }

  toJSON () {
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      identifier: this.identifier,
      phoneNumber: this.phoneNumber,
      password: this.password,
      familyId: this.familyId,
      languageId: this.languageId,
      roleId: this.roleId,
      photoId: this.photoId,
      deviceIds: this.deviceIds,
      assignedUserIds: this.assignedUserIds,
      visibleFamilyIds: this.visibleFamilyIds,
      smsDangerMessages: this.smsDangerMessages,
      smsNormalMessages: this.smsNormalMessages,
      emailDangerMessages: this.emailDangerMessages,
      emailNormalMessages: this.emailNormalMessages,
      browserNotification: this.browserNotification,
      theme: this.theme,
      hasPassword: this.hasPassword
    }
  }

  static FromJSON ({
    id,
    firstName,
    lastName,
    email,
    identifier,
    phoneNumber,
    password,
    familyId,
    languageId,
    roleId,
    photoId,
    deviceIds,
    assignedUserIds,
    visibleFamilyIds,
    smsDangerMessages,
    smsNormalMessages,
    emailDangerMessages,
    emailNormalMessages,
    browserNotification,
    theme,
    hasPassword
  }) {
    return new StoreProfile(
      id,
      firstName,
      lastName,
      email,
      identifier,
      phoneNumber,
      password,
      familyId,
      languageId,
      roleId,
      photoId,
      deviceIds,
      assignedUserIds,
      visibleFamilyIds,
      smsDangerMessages,
      smsNormalMessages,
      emailDangerMessages,
      emailNormalMessages,
      browserNotification,
      theme,
      hasPassword
    )
  }
}

export default StoreProfile
